export class PKCEUtil {
    static async generateCodeVerifier(): Promise<string> {
        const array = new Uint8Array(32);
        window.crypto.getRandomValues(array);
        // Convert Uint8Array to a regular array
        const randomString = Array.from(array)
            .map(byte => String.fromCharCode(byte))
            .join('');
        return btoa(randomString)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    static async generateCodeChallenge(verifier: string): Promise<string> {
        const encoder = new TextEncoder();
        const data = encoder.encode(verifier);
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
      
        // Convert ArrayBuffer to Uint8Array
        const hashArray = new Uint8Array(hashBuffer);
      
        // Convert Uint8Array to a Base64 URL-safe string using for...of loop
        let hashString = '';
        for (const byte of Array.from(hashArray)) {
          hashString += String.fromCharCode(byte);
        }
        
      
        return btoa(hashString)
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=+$/, '');
      }
      

}